import { createRoot, type Root } from "react-dom/client"
import App from "~/days/App"

let root: Root | null = null

const mount = () => {
  destroy()

  const container = document.querySelector("#days-app") as HTMLElement | null

  if (container === null) return

  const initialData = JSON.parse(container.dataset.initialData as string)

  root = createRoot(container)
  root.render(<App initialData={initialData.day} />)
}

const destroy = () => {
  if (root) {
    root.unmount()
    root = null
  }
}

document.addEventListener("turbo:load", mount)
document.addEventListener("turbo:before-cache", destroy)
